import React, { useEffect, useState } from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/form.module';
import GoogleSearchMap from '../../../../common/components/google-map-search';


export const NexusARecordBasicDetailsComponent = ({
  handleInnerFormChange,
  selectedNexusARecords,
  nexusARecordTypeList,
  PolicyOwnerType,
  TemplateGroupEntityType,
  templates,
  accountTypesListLoading,
  accountListLoading,
  accountsList,
  accountTypesList,
}: any) => {

  // 🌍 STATES
  const [location, setLocation] = useState<any>(null);
  const [geoFenceLocation, setGeoFenceLocation] = useState<any>(null);

  const [showGeoLocationMap, setShowGeoLocationMap] = useState(false);
  const [showGeoFenceMap, setShowGeoFenceMap] = useState(false);

  // ✅ LOAD EXISTING LAT LNG
  useEffect(() => {
    if (selectedNexusARecords?.GeoLocation) {
      const [lat, lng] = selectedNexusARecords.GeoLocation.split(",");
      setLocation({
        lat: Number(lat),
        lng: Number(lng),
        description: selectedNexusARecords.GeoLocation,
      });
    }

    if (selectedNexusARecords?.GeoFencing) {
      const [lat, lng] = selectedNexusARecords.GeoFencing.split(",");
      setGeoFenceLocation({
        lat: Number(lat),
        lng: Number(lng),
        description: selectedNexusARecords.GeoFencing,
      });
    }
  }, [selectedNexusARecords]);

  return (
    <>
      <AccordionContainer
        expandedPanel="basicInfo"
        headerTitle="Basic Details"
        child={
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">

            {/* Record Type */}
            <InputContainer
              label="Nexus A Record Type"
              labelField="Message.Name"
              list={nexusARecordTypeList}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'NexusARecordTypeId')
              }
              optionName="Choose Record Type"
              type="select"
              value={selectedNexusARecords?.NexusARecordTypeId}
              valueField="Message.Id"
            />

            {/* Level */}
            <InputContainer
              label="Level"
              labelField="Text"
              list={PolicyOwnerType}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'OwnerLevelId')
              }
              optionName="Choose Level"
              type="select"
              value={selectedNexusARecords?.OwnerLevelId}
              valueField="Value"
            />

            {/* Account Type */}
            <InputContainer
              label="Account Type"
              labelField="Name"
              list={accountTypesList}
              isLoading={accountTypesListLoading}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'OwnerTypeId')
              }
              optionName="Choose Account Type"
              type="select"
              value={selectedNexusARecords?.OwnerTypeId}
              valueField="Id"
            />

            {/* Account Name */}
            <InputContainer
              label="Account Name"
              labelField="Name"
              list={accountsList}
              isLoading={accountListLoading}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'OwnerAccountId')
              }
              optionName="Choose Account Name"
              type="select"
              value={selectedNexusARecords?.OwnerAccountId}
              valueField="Id"
            />

            {/* Hosting URL */}
            <InputContainer
              label="Hosting URL"
              type="text"
              value={selectedNexusARecords?.HostingURL}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'HostingURL')
              }
            />

            {/* FQDN */}
            <InputContainer
              label="FQDN Name"
              type="text"
              value={selectedNexusARecords?.FQDNName}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'FQDNName')
              }
            />

            {/* 🔥 GEO LOCATION */}
            <div className="col-span-1 md:col-span-2">
              <label className="block font-medium mb-1">Geo Location</label>

              {!showGeoLocationMap && selectedNexusARecords?.GeoLocation && (
                <div className="flex justify-between border p-2 rounded bg-gray-50">
                  <span className="text-sm">
                    {location?.description || selectedNexusARecords?.GeoLocation}
                  </span>
                  <button
                    className="text-blue-600 text-sm underline"
                    onClick={() => setShowGeoLocationMap(true)}
                  >
                    Edit
                  </button>
                </div>
              )}

              {showGeoLocationMap && (
                <>
                  <GoogleSearchMap
                    setLocation={(loc: any) => {
                      setLocation(loc);
                      handleInnerFormChange(`${loc.lat},${loc.lng}`, "GeoLocation");
                      handleInnerFormChange(loc.pincode || "", "PINCode");
                    }}
                    location={location}
                  />

                  <button
                    className="text-red-500 text-sm mt-2"
                    onClick={() => setShowGeoLocationMap(false)}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>

            {/* 🔥 GEO FENCING */}
            <div className="col-span-1 md:col-span-2">
              <label className="block font-medium mb-1">Geo Fencing</label>

              {!showGeoFenceMap && selectedNexusARecords?.GeoFencing && (
                <div className="flex justify-between border p-2 rounded bg-gray-50">
                  <span className="text-sm">
                    {geoFenceLocation?.description || selectedNexusARecords?.GeoFencing}
                  </span>
                  <button
                    className="text-blue-600 text-sm underline"
                    onClick={() => setShowGeoFenceMap(true)}
                  >
                    Edit
                  </button>
                </div>
              )}

              {showGeoFenceMap && (
                <>
                  <GoogleSearchMap
                    setLocation={(loc: any) => {
                      setGeoFenceLocation(loc);
                      handleInnerFormChange(`${loc.lat},${loc.lng}`, "GeoFencing");
                    }}
                    location={geoFenceLocation}
                  />

                  <button
                    className="text-red-500 text-sm mt-2"
                    onClick={() => setShowGeoFenceMap(false)}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>

            {/* PIN */}
            <InputContainer
              label="PIN Code"
              type="text"
              value={selectedNexusARecords?.PINCode}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'PINCode')
              }
            />

            {/* Unique */}
            <InputContainer
              label="Unique Code"
              type="text"
              value={selectedNexusARecords?.UniqueCode}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'UniqueCode')
              }
            />

            {/* QR */}
            <InputContainer
              label="QR Code"
              type="text"
              value={selectedNexusARecords?.QRCode}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'QRCode')
              }
            />

            {/* Order */}
            <InputContainer
              label="Display Order"
              type="number"
              value={selectedNexusARecords?.DisplayOrder}
              onValueChange={(e: any) =>
                handleInnerFormChange(e.target.value, 'DisplayOrder')
              }
            />

          </div>
        }
      />
    </>
  );
};

export default NexusARecordBasicDetailsComponent;